import Id from './base'

/**
 * A client-side Session ID is minted when a user first visits our website. It is persisted
 *   in a never-expiring cookie, and is only explicitly reset when a user logs out.
 *
 * Note: This is a _client side_ session identifier. This is totally unrelated to our backend
 *   `SessionId` type!
 *
 * See: https://dealdotcom.atlassian.net/wiki/spaces/ENGINEERING/pages/13467664/Sessionization
 */
export default class SessionId extends Id {
  public constructor(underlyingId?: string) {
    super('sessionId', underlyingId)
  }
}
